import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const show = (type, message, options = {}) => {
  const toastId = toast[type](message, {
    ...options,
  });

  const duration = options.autoClose !== undefined ? options.autoClose : 2500;
  if (duration !== false) {
    setTimeout(() => {
      toast.dismiss(toastId);
    }, duration);
  }
};

export const notify = {
  success: (message, options = {}) =>
    show("success", message, options),

  error: (message, options = {}) =>
    show("error", message, options),

  warning: (message, options = {}) =>
    show("warning", message, options),

  info: (message, options = {}) =>
    show("info", message, options),

  loading: (message = "Please wait...") =>
    toast.loading(message, {
      position: "top-right",
      theme: "light",
    }),

  update: (id, type, message) =>
    toast.update(id, {
      render: message,
      type,
      isLoading: false,
      autoClose: 2500,
      hideProgressBar: true,
    }),

  dismiss: () => toast.dismiss(),

  apiError: (
    error,
    fallback = "Something went wrong. Please try again."
  ) => {
    const data = error?.response?.data;

    const message =
      data?.message ||
      data?.msg ||
      data?.detail ||
      data?.error?.sqlMessage ||
      data?.error ||
      (error?.response
        ? `${error.response.status} - ${error.response.statusText}`
        : fallback);

    show("error", message);
  },
};